import React, { useState } from 'react';
import { Tag } from '@m4b-design/components';
import { Tooltip } from '@m4b-design/components';
import { TagInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import styles from './index.scss';
import cx from 'classnames';

interface LabelTagProps {
  tagInfo?: TagInfo[];
}

const TooltipTag = props => {
  const { item } = props;
  const [visible, setVisible] = useState(false);
  return (
    <Tag key={item.name} className={cx('mr-4 mb-4', styles.labelTagContainer)}>
      <Tooltip
        popupVisible={visible}
        content={item.name}
        onVisibleChange={() => {
          if (visible) {
            setVisible(false);
          } else {
            setTimeout(() => {
              setVisible(!visible);
            }, 400);
          }
        }}>
        <p className={styles.labelTag}>{item.name}</p>
      </Tooltip>
    </Tag>
  );
};

export const LabelTag = ({ tagInfo }: LabelTagProps) => {
  return tagInfo?.length ? (
    <span className={`inline-block mb-4 ${styles.labelTagContainer}`}>
      {tagInfo
        ?.sort((a, b) => b?.highlight_flag! - a?.highlight_flag!)
        ?.slice(0, 3)
        ?.map(item => {
          return <TooltipTag key={item.name} item={item} />;
        })}
    </span>
  ) : null;
};
